<template>
  <div>
    <div class="speaker-header">
      <div class="container">
        <div class="filter-header">
          <div>
            <h1>{{ heading ? heading : "Finn foredragsholder" }}</h1>
            <p>
              {{
                subtitle
                  ? subtitle
                  : "Vi har mange foredragsholdere registrert i vårt nettverk."
              }}
            </p>
            <input
              type="text"
              v-model="searchQuery"
              placeholder="Søk på navn eller tema …"
              class="search-field"
              @input="filterResults"
            />
          </div>
          <div class="show-filter" v-show="showFilters">
            <div>
              <strong>Velg tema</strong>
            </div>
            <div class="filter-checkboxes">
              <div
                class="checkbox"
                v-for="filter in categories"
                :key="filter.slug"
              >
                <label>
                  <input
                    type="checkbox"
                    v-model="selectedFilters"
                    :value="filter.slug"
                    @change="filterResults"
                  />
                  <span>{{ filter.title }}</span>
                </label>
              </div>
            </div>
            <button class="reset-filter" @click="resetFilters">
              Reset Filters
            </button>
          </div>
          <button class="toggle-filter" @click="toggleFilters">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path
                fill="white"
                d="M80 80l0 96 96 0 0-96L80 80zM32 80c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zM80 336l0 96 96 0 0-96-96 0zm-48 0c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zM432 80l-96 0 0 96 96 0 0-96zM336 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zm0 304l0 96 96 0 0-96-96 0zm-48 0c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96z"
              />
            </svg>
            {{ showFilters ? "Skjul filter" : "Vis filter" }}
          </button>
        </div>
      </div>
    </div>

    <div class="container results-container">
      <h3 class="title">
        Viser
        <strong>
          {{ paginatedItems.length }}
          {{
            paginatedItems.length === 1 ? "foredragsholder" : "foredragsholdere"
          }}
        </strong>
      </h3>
      <div class="filtered-results">
        <div v-for="item in paginatedItems" :key="item.id" class="speaker-card">
          <a class="link" :href="'/' + item.uri">
            <picture>
              <img :src="item.image" v-if="item.image" :alt="item.title" />
              <div v-else class="placeholder" />
            </picture>
          </a>
          <div class="text-container">
            <a class="link" :href="'/' + item.uri">
              <h5 class="title">{{ item.title }}</h5>
            </a>
            <p>{{ item.subtitle }}</p>
            <a :href="'/' + item.uri">Les mer</a>
          </div>
        </div>
      </div>
      <div class="filtered-pagination" v-if="totalPages > 1">
        <button @click="prevPage" v-if="currentPage !== 1">
          Forrige
        </button>
        <div v-else />
        <span class="font-weight-bold"
          >Side {{ currentPage }} av {{ totalPages }}</span
        >
        <button @click="nextPage" v-if="currentPage !== totalPages">
          Neste
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showFilters: false,
      searchQuery: "",
      selectedFilters: [],
      filteredItems: [],
      currentPage: 1,
      itemsPerPage: 15
    };
  },
  props: ["heading", "subtitle", "categories", "speakers", "filters"],
  computed: {
    paginatedItems() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredItems.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.filteredItems.length / this.itemsPerPage);
    }
  },
  methods: {
    toggleFilters() {
      this.showFilters = !this.showFilters;
    },
    filterResults() {
      this.filteredItems = this.speakers.filter(item => {
        const matchesSearch = item.title
          .toLowerCase()
          .includes(this.searchQuery.toLowerCase());
        const matchesFilters =
          this.selectedFilters.length === 0 ||
          this.selectedFilters.some(filter =>
            item.filters.map(f => f.slug).includes(filter)
          );
        return matchesSearch && matchesFilters;
      });
      this.currentPage = 1;
    },
    resetFilters() {
      this.searchQuery = "";
      this.selectedFilters = [];
      this.filterResults();
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    }
  },
  mounted() {
    this.filteredItems = this.speakers;

    if (this.filters) {
      this.selectedFilters = this.filters;
      this.filterResults();
    }
  }
};
</script>
<style scoped lang="scss">
.filter-checkboxes {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  max-height: 240px;
  -ms-overflow-style: none;
  overflow: auto;

  @media screen and (max-width: 767px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (min-width: 767px) and (max-width: 1200px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
}

.results-container {
  padding: 40px 20px 120px;

  .title {
    font-size: 16px;
    line-height: 20px;
  }

  .show-filter {
    margin-top: 20px;
  }
}

.filter-header {
  padding-bottom: 40px;

  .search-field {
    width: 100%;
    padding: 17px 22px;
    margin-bottom: 10px;
  }

  .toggle-filter {
    background: transparent;
    text-decoration: underline;
    color: white;
    outline: none;
    display: flex;
    align-items: center;
    gap: 10px;

    svg {
      width: 16px;
      height: 16px;
      min-width: 16px;
      text-decoration: none;
    }
  }

  .reset-filter {
    margin: 20px 0;
    background: transparent;
    text-decoration: none;
    border: 2px solid white;
    width: 100%;
    color: white;
    padding: 12px 16px;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }
  }

  .filter-checkboxes {
    margin-top: 10px;

    label {
      display: flex;
      align-items: center;

      span {
        margin-left: 10px;
        cursor: pointer;
        font-size: 16px;
        line-height: 16px;
      }
    }
  }

  .filter-checkboxes input[type="checkbox"] {
    appearance: none;
    background-color: white;
    border-radius: 4px;
    width: 22px;
    height: 22px;
    display: inline-block;
    position: relative;
    cursor: pointer;
  }

  .filter-checkboxes input[type="checkbox"]:checked {
    background-color: #ff5a6c;
  }

  .filter-checkboxes input[type="checkbox"]:checked::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 16px;
    height: 16px;
    background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="white" d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>')
      no-repeat center center;
    background-size: contain;
    transform: translate(-50%, -50%);
  }
}

.filtered-results {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 30px 20px;

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }

  @media (min-width: 600px) and (max-width: 1200px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .speaker-card {
    color: #2f4286;

    picture {
      img {
        aspect-ratio: 4/3;
        object-fit: cover;
        width: 100%;
      }

      .placeholder {
        width: 100%;
        aspect-ratio: 4/3;
        background: #ccc;
      }
    }

    .text-container {
      margin-top: 15px;

      a.link {
        text-decoration: none;

        h5.title {
          margin-bottom: 10px;
          color: #2f4286;
        }
      }

      .title {
        font-weight: bold;
        font-size: 25px;
        line-height: 30px;
      }

      p {
        font-size: 16px;
        line-height: 20px;
      }

      a {
        font-weight: bold;
        color: #2f4286;
      }
    }
  }
}

.filtered-pagination {
  padding: 50px 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;

  button {
    border: 1px solid black;
    border-radius: 4px;
    padding: 5px 12px;
    font-size: 16px;
    width: 77px;
  }

  div {
    width: 77px;
  }
}
</style>
